<template>
  <div class="page">
    <div class="topitem">
      <div class="topitem__intrword">{{ $t('_appeal_intr') }}</div>
      <div class="topitem__account">
        {{ $t('current_account') }}&nbsp;&nbsp;{{ account }}
      </div>
    </div>
    <div class="product__item" @click="selectFormShow = true">
      <div class="product__tit must">{{ $t('product') }}</div>
      <div class="product__name">{{ activeProduct.word }}</div>
      <div class="product__icon"></div>
    </div>
    <div class="item">
      <div class="item__alt must">{{ $t('appeal_code_pic') }}</div>
      <div class="item__demo" @click="demoShow = true">
        {{ $t('look_demo_img') }}
      </div>
      <uploadImage
        class="uploadImage_1"
        :limitNum="1"
        :imageList.sync="imageList1"
      ></uploadImage>
      <div class="item__email" v-show="showEmail">
        <div class="item__tit must">{{ $t('contact_email') }}</div>
        <input type="text" class="item__input" v-model="email" />
      </div>
      <div class="item__tit must">{{ $t('problem_desc') }}</div>
      <textarea class="item__textarea" v-model="description"></textarea>
      <div class="item__tit">{{ $t('orther_msg') }}</div>
      <uploadImage
        class="uploadImage_2"
        :imageList.sync="imageList2"
      ></uploadImage>
    </div>
    <selectForm
      :list="list"
      :title="$t('chose_product')"
      :show="selectFormShow"
      :mustSelectOne="true"
      :btnShow="false"
      @hide="selectFormShow = false"
      @select="selectProduct"
    ></selectForm>
    <div class="fix-fullscreen">
      <div
        class="submit-btn"
        :class="canSubmit ? 'active' : ''"
        @click="submit"
      >
        {{ $t('submit') }}
      </div>
      <div class="fullscreen__padding"></div>
    </div>
    <div class="demo__layer" v-show="demoShow" @click="demoShow = false">
      <img :src="demoImg" alt="" class="demo__img" />
    </div>
  </div>
</template>

<script>
import { appBridge, api, qs, show, Toast } from '@/utils/common';
import selectForm from '../../components/selectForm';
import uploadImage from '../../components/uploadImage';
import uploadImgList from '../../utils/uploadImgList';

export default {
  created() {
    show();
    appBridge.setTitle(this.$t('code_appeal'));
    this.appeal_id = qs.parse(location.search).appeal_id;
    // 修改申诉信息
    if (this.appeal_id) {
      api
        .getAppealDetail({
          appeal_id: this.appeal_id
        })
        .then((res) => {
          api.getProduct().then((r) => {
            r.list.forEach((v) => {
              v.word = v.name;
            });
            this.list = r.list;
            let m = r.list.filter((v) => v.elfin_pid == res.elfin_pid);
            if (m && m[0]) {
              this.activeProduct = m[0];
            }
            this.imageList1 = [res.coupon_image];
            this.description = res.description;
            this.imageList2 = res.other_image;
            this.email = res.email;
            this.account = this.hideAccount(res.email);
          });
        });
    } else {
      api.getProduct().then((res) => {
        res.list.forEach((v) => {
          v.word = v.name;
        });
        this.list = res.list;
      });
      appBridge.checkLogin('1').then(() => {
        appBridge.getUserInfo().then((res) => {
          res = JSON.parse(res);
          let account = res.mail;
          this.email = res.mail;
          if (!res.mail) {
            this.showEmail = true;
            account = res.phone;
          }
          this.account = this.hideAccount(account);
        });
      });
    }
  },
  data() {
    return {
      list: [],
      selectFormShow: false,
      activeProduct: {},
      imageList1: [],
      imageList2: [],
      description: '',
      account: '',
      email: '',
      showEmail: false,
      appeal_id: '',
      demoShow: false,
      demoImg:
        this.$lang == 'en'
          ? require('../../assets/image/account_image_cdkey_en@2x.png')
          : require('../../assets/image/account_image_cdkey_ch@2x.png'),
      lock: false
    };
  },
  computed: {
    canSubmit() {
      return (
        this.activeProduct.word &&
        this.imageList1.length &&
        this.email &&
        this.description
      );
    }
  },
  watch: {},
  methods: {
    hideAccount(account) {
      account = [...account];
      let middleIndex = Math.floor(account.length / 2);
      for (let i = 0; i < 5; i++) {
        account[middleIndex - 2 + i] = '*';
      }
      return account.join('');
    },
    submit() {
      if (!this.canSubmit || this.lock) {
        return;
      }
      this.lock = true;
      Promise.all([
        uploadImgList(this.imageList1),
        uploadImgList(this.imageList2)
      ])
        .then((arr) => {
          let postdata = {
            scenario: this.appeal_id ? 'update' : 'apply',
            coupon_image: arr[0][0],
            elfin_pid: this.activeProduct.elfin_pid,
            description: this.description,
            email: this.email,
            other_image: arr[1]
          };
          if (this.appeal_id) {
            postdata.appeal_id = this.appeal_id;
          }
          return api.postCouponAppeal(postdata).then((res) => {
            Toast(this.$t('submit_success'));
            setTimeout(() => {
              this.lock = false;
              window.location.href = './appeal_success.html';
            }, 2000);
          });
        })
        .catch((err) => {
          this.lock = false;
        });
    },
    selectProduct(index) {
      this.activeProduct = this.list[index];
      this.selectFormShow = false;
    }
  },
  components: {
    selectForm,
    uploadImage
  }
};
</script>

<style>
body {
  background-color: #f4f4f4;
}
</style>
<style lang="scss" scoped>
@import '../../assets/scss/base.scss';
.page {
  padding-bottom: 0.7rem;
}
.topitem {
  background-color: #fff;
  padding: 0.16rem;
}
.topitem__intrword {
  line-height: 0.2rem;
}
.topitem__account {
  margin-top: 0.12rem;
  color: #666;
}
.product__item {
  padding: 0 0.2rem 0 0.16rem;
  margin: 0.12rem 0;
  overflow: hidden;
  line-height: 0.56rem;
  background: #fff;
  position: relative;
}
.product__icon {
  position: absolute;
  top: 0;
  right: 0.12rem;
  height: 100%;
  width: 0.2rem;
  background: url(~@/assets/image/account_icon_arrow@2x.png) no-repeat center
    center / 12px 12px;
}
.product__tit {
  float: left;
}
.product__name {
  float: right;
}
.item {
  background: #fff;
  padding: 0.06rem 0.16rem 0.16rem;
  color: #666;
}
.item__alt {
  display: inline-block;
  color: #666;
}
.item__demo {
  margin-left: 7px;
  display: inline-block;
  color: #0dcbb8;
}
.item__textarea {
  padding: 0.1rem;
  margin: 0.06rem 0 0.22rem;
  height: 0.79rem;
  width: 100%;
  background: rgba(248, 248, 248, 1);
  border-radius: 4px;
  border: 1px solid rgba(212, 212, 212, 1);
}
.item__tit {
}
.uploadImage_1 {
  margin: 0.06rem 0 0.22rem;
}
.uploadImage_2 {
  margin: 0.04rem 0 0;
}

.fix-fullscreen {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #fff;
  // padding-bottom: constant(safe-area-inset-bottom);
  // padding-bottom: env(safe-area-inset-bottom);
}
.submit-btn {
  @extend .btn-unable;
  width: 90%;
  margin: 0.08rem auto 0.08rem;
  &.active {
    @extend .btn-able;
  }
}
.must {
  position: relative;
  &:after {
    content: '*';
    display: inline-block;
  }
}
.item__input {
  padding: 0.1rem;
  display: block;
  height: 0.4rem;
  width: 100%;
  background: rgba(248, 248, 248, 1);
  border-radius: 4px;
  border: 1px solid rgba(212, 212, 212, 1);
  margin: 0.06rem 0 0.22rem;
}

.demo__layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.demo__img {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 2.72rem;
  height: 2.88rem;
}
@media (min-width: 768px) {
  .submit-btn {
    height: 44px;
    line-height: 44px;
    font-size: 20px;
    border-radius: 6px;
  }
  .fullscreen__padding {
    height: 0;
  }
}
</style>